import GetCustomerOrdersByIdRequestModelBase from '../_generated/modelBases/get-customer-orders-by-id-request-model-base';

export default class GetCustomerOrdersByIdRequestModel extends GetCustomerOrdersByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
